import { View, Text, StyleSheet, ActivityIndicator, Image, TouchableOpacity } from 'react-native';
import { useNavigation } from 'expo-router';
import { useEffect } from 'react';
import { Ionicons } from '@expo/vector-icons';
import { useAuth } from '@/hooks/useAuth';

export default function PersonalProfileScreen() {
  const { profile } = useAuth();
  const navigation = useNavigation();

  useEffect(() => {
    navigation.setOptions({
      title: 'Meu Perfil',
      headerLeft: () => (
        <TouchableOpacity onPress={() => navigation.goBack()} style={{ paddingLeft: 4 }}>
          <Ionicons name="chevron-back" size={26} color="#C8102E" />
        </TouchableOpacity>
      ),
    });
  }, []);

  if (!profile) return <ActivityIndicator style={{ flex: 1 }} color="#C8102E" />;

  const initials = profile.full_name
    .split(' ')
    .map(w => w[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();

  return (
    <View style={styles.container}>
      {profile.avatar_url ? (
        <Image source={{ uri: profile.avatar_url }} style={styles.avatarImage} />
      ) : (
        <View style={styles.avatarCircle}>
          <Text style={styles.avatarInitials}>{initials}</Text>
        </View>
      )}
      <Text style={styles.name}>{profile.full_name}</Text>
      <Text style={styles.email}>{profile.email}</Text>
      <View style={styles.roleBadge}>
        <Text style={styles.roleText}>Personal Trainer</Text>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1, backgroundColor: '#F5F5F5', alignItems: 'center', paddingTop: 48 },
  avatarImage: {
    width: 110, height: 110, borderRadius: 55,
    marginBottom: 16, borderWidth: 3, borderColor: '#C8102E',
  },
  avatarCircle: {
    width: 110, height: 110, borderRadius: 55,
    backgroundColor: '#C8102E22', alignItems: 'center', justifyContent: 'center',
    marginBottom: 16, borderWidth: 3, borderColor: '#C8102E',
  },
  avatarInitials: { fontSize: 36, fontWeight: '700', color: '#C8102E' },
  name: { fontSize: 22, fontWeight: 'bold', color: '#1A1A1A', marginBottom: 4 },
  email: { fontSize: 14, color: '#888', marginBottom: 16 },
  roleBadge: { backgroundColor: '#C8102E', borderRadius: 12, paddingHorizontal: 14, paddingVertical: 6 },
  roleText: { color: '#fff', fontSize: 12, fontWeight: '700' },
});
